module.exports = __webpack_public_path__ + "img/Icon-block-segment-24px-transparent.8be63236.svg";